import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {getShowPrice} from "../../utils/get_show_price";
import {IUnlockChoicePrice} from "../types/IUnlockChoiceModalLayoutProps";

export const getUnlockChoicePrice = (property: IPropertyDetail | null | undefined): IUnlockChoicePrice | null => {
    if (!property || !property.price || !property.price_m2) {
        return null;
    }

    const isPriceVisible = getShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });

    return isPriceVisible ? {price: property.price, priceM2: property.price_m2, currency: property.offer.currency} : null;
};
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {getShowPrice} from "../../utils/get_show_price";
import {IUnlockChoicePrice} from "../types/IUnlockChoiceModalLayoutProps";

export const getUnlockChoicePrice = (property: IPropertyDetail | null | undefined): IUnlockChoicePrice | null => {
    if (!property || !property.price || !property.price_m2) {
        return null;
    }

    const isPriceVisible = getShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });

    return isPriceVisible ? {price: property.price, priceM2: property.price_m2, currency: property.offer.currency} : null;
};
